import { Container } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';
import { GRADIENT } from '../constant-styles';

export const OfertasSection = styled.section<{
	numberOfCarlines: number;
	hasOneCarline: boolean;
}>`
	width: 100%;
	height: ${(props) =>
		props.hasOneCarline ? 'auto' : `${props.numberOfCarlines * 100}vh`};
	min-height: fit-content;
	position: relative;

	@media screen and (max-width: 1199px) {
		height: ${(props) => props.hasOneCarline && 'fit-content'};
		display: ${(props) => props.hasOneCarline && 'block'};
		position: ${(props) => props.hasOneCarline && 'unset'};
	}

	@media screen and (min-width: 960px) {
		ul {
			list-style-type: none;
			padding: 0;
		}
	}
`;

export const OfertasStickyContainer = styled.div<{ hasOneCarline: boolean }>`
	background: ${GRADIENT.CONTENT};
	position: ${(props) => (props.hasOneCarline ? 'relative' : 'sticky')};
	top: ${(props) =>
		props.hasOneCarline ? '0' : '64px'}; // Header de VW siempre es 64px
	height: ${(props) => (props.hasOneCarline ? 'auto' : 'calc(100vh - 64px)')};
	min-height: fit-content;
	padding: ${(props) =>
		props.hasOneCarline ? '30px 0' : '0px 0px var(--size-dynamic0150) 0px'};
	overflow: hidden;

	@media screen and (max-width: 1199px) {
		height: ${(props) => props.hasOneCarline && 'fit-content'};
		display: ${(props) => props.hasOneCarline && 'block'};
		position: ${(props) => props.hasOneCarline && 'unset'};
		align-content: ${(props) => props.hasOneCarline && 'center'};
	}
`;

export const OfertaCardWrapper = styled.div`
	height: 100vh;

	& > div {
		display: flex;
		align-items: center;
	}
`;

export const ModelFrameWrapper = styled.div<{ hasOneCarline: boolean }>`
	position: ${(props) => (props.hasOneCarline ? 'relative' : 'absolute')};
	width: 100%;
	height: ${(props) => (props.hasOneCarline ? 'auto' : '100%')};
	top: 0;
	left: 0;

	@media screen and (max-width: 1199px) {
		position: ${(props) => props.hasOneCarline && 'unset'};
		height: ${(props) => props.hasOneCarline && 'fit-content'};
	}
`;

export const ModelFrameContainer = styled.div<{ hasOneCarline: boolean }>`
	height: ${(props) => (props.hasOneCarline ? 'auto' : '100vh')};
	overflow-x: hidden;
	overflow-y: hidden;

	@media screen and (min-width: 1200px) {
		display: flex;
		align-items: center;
		justify-content: space-evenly;
	}

	@media screen and (max-width: 1199px) {
		height: ${(props) => props.hasOneCarline && 'fit-content'};
	}
`;

export const DesktopSelectorContainer = styled.div`
	pointer-events: auto;
	position: relative;
	z-index: 10;
`;

export const OfertasMobileStyledContainer = styled(Container as any)`
	pointer-events: auto;
	position: relative;
	z-index: 10;
	overflow: visible;
`;

export const ModelTitleBackgroundContainer = styled.div<{
	hasOneCarline: boolean;
}>`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	align-content: center;

	//Esto nos permite que el texto haga overflow
	& * {
		overflow: visible !important;
	}

	Tablet size @media screen and (min-width: 960px) and (max-width: 1199px) {
		height: ${(props) => props.hasOneCarline && ' 25vh'};
	}
`;
